import React from 'react';
import { connect } from 'react-redux';
import { options } from 'config/reactRedux';
import { getEdition } from 'selectors/getEdition';
import Link from 'components/link';
import withStyles from 'isomorphic-style-loader/withStyles';
import I18n from 'components/i18n';
import { getBabbelHomepageUrl } from 'utils/url';
import { LANGUAGES } from 'config/types/prop';
import FourOhFourVideo from '../../assets/videos/404-talker.mp4';

import styles from './notFound.css';

const NotFound = ({ currentEdition }) => {
  const babbelHomepageUrl = getBabbelHomepageUrl(currentEdition);
  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        <video // eslint-disable-line jsx-a11y/media-has-caption
          autoPlay
          muted
          loop
          className={styles.talkerVideo}
          src={FourOhFourVideo}
        />
        <span className={styles.fourOhFourNumber}>404</span>
        <div className={styles.divider} />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.ctaText}>
          <div className={styles.notFoundMessage}>
            <I18n
              field="no-page-found2"
              defaultText="Looks like this page doesn't exist..."
            />
          </div>
        </div>
        <Link to={babbelHomepageUrl} className={styles.linkButton}>
          <I18n
            field="no-page-found3"
            defaultText="Go to Babbel Homepage"
          />
        </Link>
      </div>
    </section>
  );
};

NotFound.propTypes = {
  currentEdition: LANGUAGES.isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: getEdition(state),
});

const withRedux = connect(
  mapStateToProps,
  undefined,
  undefined,
  options,
);

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(withRedux(NotFound));
